// Import generated versions (created by I18nManifestPlugin during build)
// Next line needed for pipeline! Do NOT delete it
// eslint-disable-next-line
import {i18nVersions} from './i18n-versions.generated';

type TLoadPathFunction = (lngs: readonly string[], namespaces: readonly string[]) => string;

/**
 * Creates a loadPath function for i18next backend that includes version query parameters.
 *
 * @param {string} basePath - Base path for i18n files (e.g., '/assets/lamapoll/i18n')
 * @returns {Function} - loadPath function for i18next backend
 */
export function createVersionedLoadPath(basePath: string): TLoadPathFunction {
  //If not used with i18next-multiload-backend-adapter, lngs and namespaces will have only one element each
  return (lngs: readonly string[], namespaces: readonly string[]): string => {
    const lng: string = lngs[0];
    const ns: string = namespaces[0];
    const version: string | undefined = i18nVersions[ns];
    const versionParam: string = version ? `?v=${version}` : '';
    return `${basePath}/${lng}/${ns}.json${versionParam}`;
  };
}
